import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
import { Button, AuthFlowLayout, } from "@pangeacyber/react-mui-authn";
var FlowReturnView = function (_a) {
    var reset = _a.reset;
    var theme = useTheme();
    var buttons = (_jsx(Button, { color: "secondary", onClick: reset, children: "Back to Log in" }));
    return (_jsx(AuthFlowLayout, { title: "Verification Complete", buttons: buttons, children: _jsx(Typography, { variant: "body2", textAlign: "center", sx: { padding: "0 16px", color: theme.palette.text.secondary }, children: "Please return to the browser where you started this flow to continue." }) }));
};
export default FlowReturnView;
